import React, { useRef, useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import i18n from '../../../i18n';
import { Section, Container, Flex, Text, Carousel, CarouselItem, IconButton } from '@homeexchange/design';
import { HomeCard } from './homecard';
import { trackButtonClick } from '../../../utils/utils-ts';
import styles from './recommendationsCarousel.module.scss';
import useFavoriteModals from '../../../hooks/useFavoriteModals';
export var RecommendationsCarousel = function (_a) {
    var _b;
    var recommendations = _a.recommendations, recommendationsTotal = _a.recommendationsTotal, user = _a.user, isLogged = _a.isLogged, recommendationsSeeMore = _a.recommendationsSeeMore;
    var carouselRef = useRef(null);
    var _c = useState({
        shouldDisplayNext: false,
        shouldDisplayPrev: false
    }), navigationState = _c[0], setNavigationState = _c[1];
    var homeFavorites = useSelector(function (state) { return state.homeFavorites || []; });
    var _d = useFavoriteModals({
        trackingArea: 'search_results'
    }), handleFavoriteClick = _d.handleFavoriteClick, handleRemoveFavorite = _d.handleRemoveFavorite, handleMoveFavorite = _d.handleMoveFavorite, modals = _d.modals;
    var handleToggleFavorite = useCallback(function (homeId, prefillName) {
        handleFavoriteClick(homeId, prefillName);
    }, [handleFavoriteClick]);
    var handleNextClick = function () {
        if (carouselRef.current) {
            carouselRef.current.scrollNext();
        }
    };
    var handlePrevClick = function () {
        if (carouselRef.current) {
            carouselRef.current.scrollPrev();
        }
    };
    var locale = i18n.language;
    var isUserCollection = (_b = user === null || user === void 0 ? void 0 : user.isCollection) === null || _b === void 0 ? void 0 : _b.call(user);
    var handleCTAClick = function () {
        var _a;
        trackButtonClick('recommendation_carousel', 'click_recommendation_carrousel_cta', (_a = user === null || user === void 0 ? void 0 : user.isCollection) === null || _a === void 0 ? void 0 : _a.call(user));
    };
    var addSearchTypeToUrl = function (url) {
        if (!url)
            return url;
        var urlObj = new URL(url, window.location.origin);
        urlObj.searchParams.set('search_type', 'recommendation');
        return urlObj.pathname + urlObj.search;
    };
    if (!recommendations || recommendations.length < 8) {
        return null;
    }
    return (React.createElement("div", { "data-theme": "regular", className: styles['carousel-container'] },
        React.createElement(Section, { isTopBottomPadding: true, color: "tertiary" },
            React.createElement(Container, { isFluid: true },
                React.createElement(Flex, { gap: "8" },
                    React.createElement(Flex, { direction: "row", gap: "1", justifyContent: "space-between", alignItems: "center", isFullWidth: true },
                        React.createElement(Flex, { direction: "column", gap: "1" },
                            React.createElement(Text, { isBold: true, size: "lg" }, i18n.t('search:page.search.closeDates.carrousel.title')),
                            React.createElement(Text, null, i18n.t('search:page.search.closeDates.carrousel.subheader'))),
                        React.createElement(Flex, { direction: "row", gap: "4", hideOnMobile: true },
                            React.createElement(IconButton, { hierarchy: "ghost", icon: "ArrowLeft", size: "large", "aria-label": "Previous", onClick: handlePrevClick, disabled: !navigationState.shouldDisplayPrev }),
                            React.createElement(IconButton, { hierarchy: "ghost", icon: "ArrowRight", size: "large", "aria-label": "Next", onClick: handleNextClick, disabled: !navigationState.shouldDisplayNext }))),
                    React.createElement(Carousel, { ref: carouselRef, onNavigationStateChange: setNavigationState, paddingElementWrapper: true, itemsPerBreakpoint: {
                            xs: { items: 1, peek: 15 },
                            sm: { items: 1, peek: 15 },
                            md: { items: 2, peek: 60 },
                            lg: { items: 3, peek: 50 },
                            xl: { items: 3, peek: 50 }
                        } }, recommendations.map(function (home, index) { return (React.createElement(CarouselItem, { key: index },
                        React.createElement(HomeCard, { result: home, locale: locale, isLogged: isLogged, isUserCollection: isUserCollection, homeFavorites: homeFavorites, handleToggleFavorite: handleToggleFavorite, onRemoveFavorite: handleRemoveFavorite, onMoveFavorite: handleMoveFavorite, format: "list", hideFixedDates: false, user: user, trackingEvent: 'click_recommendation_carrousel', origin: 'suggestion_carousel' }))); }))))),
        modals));
};
